import { render, staticRenderFns } from "./RegistrationDocumentAddDialog.vue?vue&type=template&id=01d3f8f0&lang=pug&"
import script from "./RegistrationDocumentAddDialog.vue?vue&type=script&lang=ts&"
export * from "./RegistrationDocumentAddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports